import IconArrow from './Arrow'
import IconEmail from './Email'
import IconUser from './User'

export { IconArrow, IconEmail, IconUser }
